<template>
  <q-page fluid style="min-height: 0px">
    <div class="row">
      <div ref="titleOfPage" class="col-12 text-center">
        <h4 class="q-py-none q-mb-md" style="font-family: 'Outfit', cursive">
          Your Profile
        </h4>
      </div>
      <div v-if="false" class="col-12 q-mt-md">
        <q-btn
          :disable="currentUserData.hasGoogleLogin"
          @click="changeEmailDialog = true"
          size="md"
          class="full-width"
          outline
        >
          Change Email
        </q-btn>
      </div>
      <div v-if="currentUserData.emailVerified == 0" class="col-12 q-mt-md">
        <q-btn
          :disable="currentUserData.hasGoogleLogin"
          size="md"
          class="full-width"
          outline
          @click="verifyEmailDialog = true"
        >
          Verify Email
        </q-btn>
      </div>
      <div class="col-12 q-mt-md">
        <q-btn
          :disable="currentUserData.hasGoogleLogin"
          size="md"
          class="full-width"
          outline
          @click="changePasswordDialog = true"
        >
          Change Password
        </q-btn>
      </div>
    </div>
    <q-dialog v-model="changeEmailDialog" max-width="600px">
      <q-card
        v-if="changeEmailDialog"
        tile
        style="width: 90vw; max-width: 600px"
      >
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Change Email
            </div>
            <q-space />
            <q-btn
              color="white"
              round
              flat
              icon="mdi-close"
              @click="changeEmailDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <q-form ref="changeEmailRequestForm">
            <div class="row">
              <div class="col-12">
                <q-input
                  label="New Email"
                  v-model="formData.email"
                  :rules="[
                    (v) => !!v || 'Email is required',
                    (v) => /.+@.+/.test(v) || 'Email must be valid',
                  ]"
                ></q-input>
              </div>
            </div>
          </q-form>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                label="Change Email"
                color="green"
                class="full-width"
                @click="requestEmailChange()"
                :loading="emailChangeRequestLoading"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="verifyEmailDialog" max-width="600px">
      <q-card
        v-if="verifyEmailDialog"
        tile
        style="width: 90vw; max-width: 600px"
      >
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Verify Email
            </div>
            <q-space />
            <q-btn
              color="white"
              round
              flat
              icon="mdi-close"
              @click="verifyEmailDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <q-form ref="verifyEmailRequestForm">
            <div class="row">
              <div class="col-12">
                <q-input
                  label="Verification Code"
                  v-model="formData.verificationCode"
                  :rules="[(v) => !!v || 'Verification Code is required']"
                ></q-input>
              </div>
            </div>
          </q-form>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                label="Change Email"
                color="green"
                class="full-width"
                @click="requestEmailVerify()"
                :loading="emailVerifyRequestLoading"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="changePasswordDialog" max-width="600px">
      <q-card
        v-if="changePasswordDialog"
        tile
        style="width: 90vw; max-width: 600px"
      >
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Change Password
            </div>
            <q-space />
            <q-btn
              color="white"
              round
              flat
              icon="mdi-close"
              @click="changePasswordDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <q-form ref="changePasswordRequestForm">
            <div class="row">
              <div class="col-12">
                <q-input
                  id="password"
                  :rules="[(v) => !!v || 'Current Password is required']"
                  label="Current Password"
                  name="password"
                  v-model="formData.prevPassword"
                  required
                  :type="passwordVisible ? 'password' : 'text'"
                >
                  <template #prepend>
                    <q-icon name="mdi-lock" />
                  </template>
                  <template #append>
                    <q-icon
                      :name="passwordVisible ? 'mdi-eye-off' : 'mdi-eye'"
                      class="cursor-pointer"
                      @click="passwordVisible = !passwordVisible"
                    />
                  </template>
                </q-input>
              </div>
              <div class="col-12">
                <q-input
                  id="newPassword"
                  :rules="passwordRules"
                  label="New Password"
                  name="newPassword"
                  v-model="formData.newPassword"
                  required
                  :type="passwordVisible ? 'password' : 'text'"
                >
                  <template #prepend>
                    <q-icon name="mdi-lock" />
                  </template>
                  <template #append>
                    <q-icon
                      :name="passwordVisible ? 'mdi-eye-off' : 'mdi-eye'"
                      class="cursor-pointer"
                      @click="passwordVisible = !passwordVisible"
                    />
                  </template>
                </q-input>
              </div>
              <div class="col-12">
                <q-input
                  id="comfirmPassword"
                  :rules="[
                    (v) =>
                      v == formData.newPassword || 'Passwords do not match',
                  ]"
                  label="Confirm Password"
                  name="comfirmPassword"
                  v-model="comfirmPassword"
                  @keyup.enter="requestPasswordChange"
                  required
                  :type="passwordVisible ? 'password' : 'text'"
                >
                  <template #prepend>
                    <q-icon name="mdi-lock" />
                  </template>
                  <template #append>
                    <q-icon
                      :name="passwordVisible ? 'mdi-eye-off' : 'mdi-eye'"
                      class="cursor-pointer"
                      @click="passwordVisible = !passwordVisible"
                    />
                  </template>
                </q-input>
              </div>
            </div>
          </q-form>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                label="Change Password"
                color="green"
                class="full-width"
                @click="requestPasswordChange()"
                :loading="changePasswordRequestLoading"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {},
  computed: {
    ...mapGetters(["currentUser", "currentUserData"]),
  },
  props: {
    source: String,
  },
  watch: {},
  data: () => ({
    formData: {},
    changeEmailDialog: false,
    emailChangeRequestLoading: false,
    verifyEmailDialog: false,
    emailVerifyRequestLoading: false,
    changePasswordDialog: false,
    changePasswordRequestLoading: false,
    passwordVisible: true,
    comfirmPassword: "",

    passwordRules: [
      (v) => !!v || "Password is required",
      (v) => (v && v.length >= 8) || "Password must have 8+ characters",
      (v) =>
        (v && /(?=.*[A-Z])/.test(v)) ||
        "Password Must contain a capital letter",
      (v) =>
        (v && /(?=.*[a-z])/.test(v)) ||
        "Password Must contain a lowercase letter",
      (v) => (v && /.*[0-9].*/.test(v)) || "Password Must contain a number",
      (v) =>
        (v && /[!@#$%^&*?~]/.test(v)) ||
        "Password must have a special character",
    ],
  }),
  mounted() {
    setTimeout(() => {
      this.maxHeight =
        this.$refs.titleOfPage.clientHeight +
        this.$refs.footerOfPage.clientHeight +
        20;
    }, 100);
  },
  methods: {
    handleClick(evt, row, index) {
      this.selected = [row];
    },
    handleDoubleClick(evt, row, index) {
      this.$router.push("/mobile-view/mp-survey");
    },
    requestEmailChange() {
      this.$refs.changeEmailRequestForm.validate().then((result) => {
        if (result) {
          this.emailChangeRequestLoading = true;
          this.$store
            .dispatch("userEmailChangeRequest", this.formData)
            .then((result) => {
              this.emailChangeRequestLoading = false;
              if (result.Result == "Success") {
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: "Verification Email sent",
                  caption:
                    "We have sent you a verification email to the email address given.",
                  timeout: 10000,
                });
                this.changeEmailDialog = false;
                this.$store.dispatch("logout");
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message:
                    "There was an error, Please make sure the email is a valid email address",
                  timeout: 10000,
                });
              }
            });
        }
      });
    },
    requestEmailVerify() {
      this.$refs.verifyEmailRequestForm.validate().then((result) => {
        if (result) {
          this.emailVerifyRequestLoading = true;
          this.$store
            .dispatch("userEmailVerification", this.formData)
            .then((result) => {
              this.emailVerifyRequestLoading = false;
              if (result.Result == "Success") {
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: "Success",
                  caption: "Your email has been verified",
                  timeout: 10000,
                });
                this.verifyEmailDialog = false;
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message:
                    "There was an error, Please make sure your verification code is correct",
                  timeout: 10000,
                });
              }
            });
        }
      });
    },
    requestPasswordChange() {
      this.$refs.changePasswordRequestForm.validate().then((result) => {
        if (result) {
          this.changePasswordRequestLoading = true;
          this.$store
            .dispatch("resetPasswordChangeRequest", this.formData)
            .then((result) => {
              this.changePasswordRequestLoading = false;
              if (result.Result == "Success") {
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: "Success",
                  caption: "Password has been changed",
                  timeout: 10000,
                });
                this.changePasswordDialog = false;
                this.$store.dispatch("logout");
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an error, Please Try again",
                  timeout: 10000,
                });
              }
            });
        }
      });
    },
  },
};
</script>
